// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"accounting-terms_subHeader___hQBC","linkList":"accounting-terms_linkList__YqXjv"};